angular.module('swapick')
.controller('CanHaveCtrl', CanHaveCtrl);


function CanHaveCtrl($scope, DataService, DataStrategies, $ionicLoading,
  ionPullUpFooterState, $timeout, $ionicScrollDelegate, $stateParams,
  Filters, Categories, initialLoaderManager, $q, Districts, $state) {

  this.objects = [];
  this.meta = {};
  this.offset = 0;
  this.categories = null;
  this.filters = { mondo:null, categoria:null, district:null};
  this.footerState = ionPullUpFooterState.EXPANDED;
  this.loading = false;
  this.firstLoad = false;
  this.fromObject = $stateParams.fromObject;

  DataStrategies.createPagerMethods(
    this,
    $scope,
    {
      method: DataService.itemsIcanGet,
      callMethodName : 'get', hasSearch: true,
      itemsGetter: resp => resp.items,
      itemsTransformer : (items) => _.uniqBy(_.map(items, i=>{
        let p = i.posseduto_da;
        i.posseduto_da = [p]; return i; }
      ),'id'),
      params : () => (
        {
          cat_id : this.filters.categoria,
          world_id : this.filters.mondo,
          item_id : this.fromObject ? this.fromObject.id : null,
          district_id : this.filters.district ? this.filters.district.id : null
        }
      )
    }
  );


  this.loader = initialLoaderManager.makeLoader(() => {
    return Districts
    .getDistricts()
    .then(districts => {
      this.districts = districts;
      return Categories.getCategories()
    })
    .then(categories => {
      this.filters = {
        mondo: Filters.getFilter('canhave.mondo'),
        categoria: Filters.getFilter('canhave.categoria'),
        district: Filters.getFilter('canhave.district'),
        //search : null
      };
      this.categoriesData = Categories.data;
      return this.loadPage();
    });

  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.objects.length){
        this.loader.load();
      }
  });

  $scope.$on('$ionicView.afterEnter', () => {
    $ionicScrollDelegate.resize();
  });


  this.updateFromFilters = () => {
    if(!this.filters.mondo){
      this.filters.categoria = null;
    }

    const currentFilters = {
      mondo : Filters.getFilter('home.mondo'),
      categoria : Filters.getFilter('home.categoria'),
      district : Filters.getFilter('home.district'),
    }

    if(currentFilters.mondo != this.filters.mondo || currentFilters.categoria != this.filters.categoria || (this.filters.district && currentFilters.district != (this.filters.district ? this.filters.district.id :null) )){
      this.objects = [];
      $ionicScrollDelegate.scrollTop();
      this.loadMore();
    }

    Filters.setFilter('home.mondo', this.filters.mondo);
    Filters.setFilter('home.categoria', this.filters.categoria);
    Filters.setFilter('home.district', this.filters.district);

  }


  this.getCategoriesForFilter = () => {
    if(!this.filters.mondo){
      return this.categories;
    }
    return this.categoriesData.categoriesByMondo[this.filters.mondo]
  }

  this.closeFilters = function(){
    $timeout(()=>{
      this.footerState = ionPullUpFooterState.COLLAPSED;
    });
  };

  this.clearFilters = () => {
    $timeout(()=>{
      this.filters.mondo = null;
      this.filters.categoria = null;
      this.filters.district = null;
      this.footerState = ionPullUpFooterState.COLLAPSED;
      this.updateFromFilters();
    });
  };

  this.hasFilters = function(){
    return this.filters.mondo || this.filters.categoria || this.filters.district;
  };

  this.filtersDisplay = () => {
    if(this.hasFilters()){
      let mondo = this.filters.mondo ? `${this.categoriesData.mondiById[this.filters.mondo][0]['nome']}` : '';
      let cat = this.filters.categoria ? `: ${this.categoriesData.categoriesById[this.filters.categoria][0].nome}` : '';
      let prov = this.filters.district ? ` (${this.filters.district.automobile})` : '';
      return `${mondo}${cat}${prov}`;
    }
    return '<i class="icon ion-funnel"></i> Filtra la lista';
  };

  this.toObjPage = (obj) => {
    if(this.fromObject){
      return $state.go("app.logged.swap",
        {
          yourObjectId:obj.id, yourUserId:obj.posseduto_da[0].user.id, myObjectsIds:this.fromObject.id
        }
      );
    }

    return $state.go("app.logged.object",
      {objectId:obj.id, userId:obj.posseduto_da[0].user.id, objFromList:obj}
    );
  }

}



// WEBPACK FOOTER //
// ./src/controllers/can-have-controller.js